- var utils = require('@scoutgg/ftw/source/lib/utils')

style= require('./leagues.styl')
.title
  .filters
    if this.seasons
      .row
        ft-dropdown.dropdown(icon)
          .header.dropdown-header(slot="header")
            if this.sport
              .dropdown-icon
                ft-icon(name=`sports--${this.sport}`)
            span.dropdown-text=(this.sport) || 'All sports'
          each s in this.sports
            .dropdown-item(role='option', value=s, (click)=this.changeSport(s),selected=(s == this.sport))
              if s
                .dropdown-icon
                  ft-icon(name=`sports--${s}`)
              span= s
    .controls
      input.name(
        name="name",
        type="text",
        value=this.newLeagueName,
        placeholder="New League Name",
        (input)=this.newLeagueName = e.target.value
      )
      input.year(
        name="year",
        type="number",
        value=this.newLeagueYear,
        placeholder="year",
        (input)=this.newLeagueYear = e.target.value
      )
      ft-button.create-league(success, (click)=this.createLeague()) Create League
      ft-toggle(
        checked=showInactive,
        (change)=this.showInactive = !this.showInactive
      ) Show Inactive
      .upload
        form.csv(
          ref="season-json",
          id="season-json",
          method="POST"
          action=uploadSeasonJsonPath,
          encType="multipart/form-data"
          )
          input(type="submit")
          input(type="file" name="dump" accept=".json")
.leagues
  each league in filteredLeagues
    if !league.sportChanging
      .league
        section.league_id((click)=this.toggleLeague(league))
          ft-icon.sport(name=`sports--${league.sport}`)
          .league-header= league.name
          .league-updated= `Last update: ${lastUpdate(league)}`
        if league === showLeague
          - const seasonsSorted = this.sortedSeasons(league)
          section.head
            .left
              .sports
                ft-dropdown.dropdown(icon)
                  .dropdown-header(slot="header")
                    if league.sport
                      .dropdown-icon
                        ft-icon(name=`sports--${league.sport}`)
                    span.dropdown-text=(league.sport) || 'All sports'
                  each s in sports
                    .dropdown-item(role='option', value=s, (click)=this.isGoingToChangeSport(league, s), selected= (league.sport === sport))
                      if s
                        .dropdown-icon
                          ft-icon(name=`sports--${s}`)
                      span= s
              form.league-name((submit)=this.rename(league, e))
                section
                  input.name(
                    name="name",
                    tabindex=1,
                    type="text",
                    value=league.name,
                    (input)=league.name = e.target.value)
                  ft-button(subtle, (click)=this.rename(league))
                    ft-icon(name=`ui--edit`)
            if $showForm === league
              form.right_side(method="post" action="/seasons")
                input(type="hidden" name="league" value=league)
                label Year
                input.year(
                  name="season"
                  type="number"
                  value=( new Date().getFullYear() )
                )
                button Submit
            else
              ft-button.right_side(success, (click)=this.showForm(league))
                | Create Season
          section.seasons
            if seasonsSorted && seasonsSorted.length
              each season, index in seasonsSorted
                section.id_section
                  ft-clipboard
                    span= season._id
                    span.match-icon
                      ft-icon(name=`ui--clipboard`)
                  span.uid= season.season
                  .padding
                  ft-button(
                    notice,
                    href=`/seasons/${season._id}/dump.json`
                  ) Download Dump
                  ft-button(
                    warning,
                    (click)=this.copy(season)
                  ) Copy Season
                  ft-button(
                    danger,
                    (click)=this.destroy(season)
                  ) Delete Season
                .season_checkboxes(class=seasonClass(season))
                  section
                    ft-toggle.year(
                      (change)=this.toggle(season, 'active'),
                      checked=season.active
                    )= season.season
                    ft-toggle.year(
                      (change)=this.toggle(season, 'showStats'),
                      checked=season.showStats
                    ) Show Stats
                    ft-toggle.year(
                      (change)=this.toggle(season, 'sportsbookOnly'),
                      checked=season.sportsbookOnly
                    ) Sportsbook League
                    ft-toggle.year(
                      (change)=this.toggle(season, 'autoconfirm'),
                      checked=season.autoconfirm
                    ) Autoconfirm Events
                    ft-toggle.year(
                      (change)=this.toggle(season, 'skipCompute'),
                      checked=season.skipCompute
                    ) Skip Computations
                .season(class=seasonClass(season))
                  if season.active
                    if $showForm !== season
                      .main
                        .header
                          span Sources
                          section.hi
                            .source
                              if $showForm !== season
                                ft-button(success, (click)=this.showForm(season))
                                  | Create Source
                            .livestream
                              input(
                                name="livestreamurl",
                                type="text",
                                value=season.liveStreamUrl,
                                placeholder="Live stream URL",
                                (input)=season.liveStreamUrl = e.target.value
                              )
                              input(
                                name="livestreamsource",
                                type="text",
                                value=season.liveStreamSource,
                                placeholder="Live stream source (e.g. 'twitch')",
                                (input)=season.liveStreamSource = e.target.value
                              )
                              ft-button(
                                success,
                                disabled=season.$isSubmitting,
                                (click)=this.saveLiveSteam(season)
                              ) Save
                        section.sources
                          each source in this.sourcesFor(season)
                            .source-actions
                              if sourceProperty(source, 'token')
                                ft-button(
                                  warning,
                                  disabled=source.$isScraping,
                                  (click)=this.revealToken(source)
                                ) Reveal Token
                              if sourceProperty(source, 'fullScrape')
                                ft-button(
                                  danger,
                                  disabled=source.$isScraping,
                                  (click)=this.scrape(source, '-full')
                                )
                                  .label= source.source
                                  span Full Scrape
                              if sourceProperty(source, 'old')
                                ft-button(
                                  danger,
                                  disabled=source.$isScraping,
                                  (click)=this.scrape(source, '-old')
                                )
                                  .label= source.source
                                  span Scrape w/old
                              .scrape
                                ft-button(
                                  warning,
                                  disabled=source.$isScraping || !source.sport,
                                  (click)=this.scrape(source)
                                )
                                  .label= source.name
                                  span #{source.uid || ''} (#{[source.strategy || 'league', source.year||'N/A'].join(', ')})
                                if this.canScrapeFrom(source)
                                  small Scrape from:
                                  ft-calendar(
                                    secondary,
                                    date=source.scrapeFrom,
                                    placeholder='Scrape from',
                                    (dateChanged)=this.updateScrapeFrom(source, e.value)
                                  )
                              .source-toggles
                                if sourceProperty(source, 'auto')
                                  ft-toggle(
                                    checked=source.disabled,
                                    (toggle)=this.toggleAuto(source),
                                  ) Disable Scraping
                                  if source.token
                                    input(readonly value=source.token)
                                if sourceProperty(source, 'flexibleUids')
                                  form.source-name((submit)=this.changeSource('uid', source, e))
                                    Change UID
                                    input.name(
                                      name="name",
                                      tabindex=1,
                                      type="text",
                                      value=source.uid,
                                      (input)=source.uid = e.target.value)
                                  ft-button.warning(subtle, (click)=this.changeSource('uid', source))
                                    ft-icon(name=`ui--edit`)
                                  form.source-name((submit)=this.changeSource('strategy', source, e))
                                    Change Strategy
                                    input.name(
                                      name="strategy",
                                      tabindex=1,
                                      type="text",
                                      value=source.strategy,
                                      (input)=source.strategy = e.target.value)
                                  ft-button.warning(subtle, (click)=this.changeSource('strategy', source))
                                    ft-icon(name=`ui--edit`)

                    if $showForm !== season
                      section.send
                        if season.active
                          .header= 'Prices & Fixtures'
                          .sub_part
                            .source
                              ft-button(success,
                                disabled=season.$isSubmitting,
                                (click)=this.send(season, 'fixtures')
                              ) Send Fixtures
                              ft-button(notice,
                                href=`/seasons/${season._id}/fixtures`
                              ) Download Feed
                              ft-button(success,
                                disabled=season.$isSubmitting,
                                (click)=this.send(season, 'prices')
                              ) Send Prices
                              ft-button(notice,
                                href=`/seasons/${season._id}/price-feeds`
                              ) Download Feed
                    if $showForm === season
                      section.source-selection
                        form(method="post" action="/season-sources")
                          input(type="hidden" name="season" value=season)
                          select(name="source")
                            option(value="" disabled selected)= 'Select source'
                            each source in sources(league)
                              option(value=source.id)= source.name
                          input(type="text" name="uid", placeholder='Type UID')

                          if this.canScrapeFrom(season.sport)
                            input(type="hidden", name="scrapeFrom", value=this.scrapeFrom)
                            ft-calendar(
                              secondary,
                              placeholder='Scrape from',
                              (dateChanged)=this.render(this.scrapeFrom = e.value)
                            )

                          input(type="number" name="year" placeholder='Season ID'  value=season.season)
                          if !this.customStrategy
                            select(name="strategy")
                              option(value="" disabled selected)= 'Source type'
                              each strategy in ['league', 'cup']
                                option= strategy
                          ft-toggle(
                              checked=this.customStrategy,
                              (toggle)=this.render(this.customStrategy = !this.customStrategy),
                          ) Custom strategy
                          if this.customStrategy
                            input(type="text" name="strategy" value=season.strategy)
                          button.button='Create Source'
                section.whitelabels
                  span= 'Whitelabels'
                  .toggles
                    each receiver in receivers
                      ft-toggle.receiver(
                        (change)=this.toggleReceiver(season, receiver)
                        checked=!!~season.receivers.indexOf(receiver._id)
                      )= receiver.name
    else
      .sportChangingConfirmation
        p= 'You want to switch kind of sport for'
        .league-name= league.name
        .sports
          .sport-name
            ft-icon(name=`sports--${league.sport}`)
            span= league.sport
          ft-icon(name=`ui--transfer`)
          .sport-name
            ft-icon(name=`sports--${league.temporarySport}`)
            span= league.temporarySport
        .buttons
          button.decline((click)= this.dontSetSport(league))= 'Decline'
          button.confirm((click)= this.setSport(league, sport))= 'Confirm'
